import axios from '../../../../utils/request';

function GET_AROLE(params) {
    return axios.get("/dictionary/AVisitorSource/index",{
        params: {
            page:params
        }
    } )
}
function SUBMIT_ADD(params) {
    return  axios.post("/dictionary/AVisitorSource/addPost",{...params} )
}
function EDIT_DATA(params) {
    return  axios.post("/dictionary/AVisitorSource/edit",  {
            ...params
        }  )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/dictionary/AVisitorSource/editPost",{...params} )
}


export default {
    GET_AROLE,
    SUBMIT_ADD,
    EDIT_DATA,
    SUBMIT_EDIT,
};